module.exports = __webpack_public_path__ + "img/sin info apertura.ed17bdd3.svg";